import { Brand } from '@omniafishing/core';
import React from 'react';
import { useFrontload } from 'react-frontload';
import { useDispatch } from 'react-redux';
import { LAKE_HERO_TAG } from '../components/content_list/content_list';
import { apiV1 } from '../lib/api';
import { PrismicTagPrefixes } from '../prismic';
import { fetchBrandAmbassadors } from '../redux/brands';
import { fetchPrismicQasByTag } from '../redux/pages';
import { BrandPage } from './brand_page';

interface OwnProps {
  brand: Brand;
}

const BrandPageContainer = (props: OwnProps) => {
  const { brand } = props;
  const { name, url_slug } = brand;
  const dispatch = useDispatch();

  const { data } = useFrontload(`BrandPageContainer:${name}`, async () => {
    const tag = `${PrismicTagPrefixes.BRAND}${name}`;
    const [mediaRes] = await Promise.all([
      apiV1.mediaFetch({
        per_page: 100,
        brands: [name],
        exclude_tags: [LAKE_HERO_TAG],
      }),
      dispatch(fetchPrismicQasByTag(tag)),
      // are ambassadors critical to the page?
      dispatch(fetchBrandAmbassadors(url_slug)),
    ]);

    return {
      media: mediaRes.data.data,
    };
  });

  return <BrandPage brand={brand} media={data?.media || []} />;
};

export default BrandPageContainer;
